export const SET_UPLOAD_PROGRESS = "files/SET_UPLOAD_PROGRESS";
export const SUCCESS_UPLOAD_FILE = "files/SUCCESS_UPLOAD_FILE";
export const FAILURE_UPLOAD_FILE = "files/FAILURE_UPLOAD_FILE";
export const SET_UPLOAD_FILE = "files/SET_UPLOAD_FILE";
export const CLEAR_FILE_LIST = "files/CLEAR_FILE_LIST";
export const SET_UPLOADING = "files/SET_UPLOADING";
